import { useRef, useCallback, useEffect } from 'react';
import { jsx } from 'react/jsx-runtime';

const OutsideAlerter=a=>{let{children:b,onClickOutside:c}=a;const d=useRef(),e=useCallback(a=>{const{current:b}=d,e=c&&b&&!b.contains(a.target);e&&"function"==typeof c&&c(a);},[c,d]);/**
   * Alert if clicked on outside of element.
   * @param {Object} event The on `mousedown` `callback`.
   */return useEffect(()=>(document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e);}),[e]),/*#__PURE__*/jsx("div",{ref:d,children:b})};OutsideAlerter.displayName="OutsideAlerter";

export { OutsideAlerter as default };
